import { takeLatest, call, put, select } from 'redux-saga/effects';

// Services
import { denylistApi } from 'services/apiDigitalTicket/denylist';

// Actions
import * as DialogsActions from 'store/ducks/dialogs/actions';
import * as SnackbarsActions from 'store/ducks/snackbars/actions';

// Constants
import { errorMessagersList } from 'helpers/errorMessagers';

import * as DenylistActions from './actions';
import * as UsersActions from '../users/actions';
import { DenyListTypes } from './types';

function* list(): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({ title: 'Carregando restrictionList' }),
    );
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );
    const response = yield call(denylistApi.get, {
      params: { transportOperatorId: transportOperator.id },
    });

    if (response.status === 200) {
      yield put(
        DenylistActions.listDenylistSuccess({
          denylistList: response.data,
        }),
      );
      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('restrictionList - listRestrictionList - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(DenylistActions.listDenylistFailure());
    yield put(DialogsActions.setClose());
  }
}

function* get({
  payload,
}: ReturnType<typeof DenylistActions.getDenylistRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Carregando dados' }));
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );
    const response = yield call(denylistApi.get, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        DenylistActions.getDenylistSuccess({ denylistData: response.data }),
      );
      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('restrictionList - getRestrictionList - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(DenylistActions.getDenylistFailure());
    yield put(DialogsActions.setClose());
  }
}

function* create({
  payload,
}: ReturnType<typeof DenylistActions.createDenylistRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Criando item' }));
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );
    const response = yield call(denylistApi.create, {
      data: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        DenylistActions.createDenylistSuccess({ denylistData: response.data }),
      );
      yield put(DialogsActions.setClose());
      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Item criado com sucesso',
        }),
      );
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('restrictionList - createRestrictionList - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(DenylistActions.createDenylistFailure());
    yield put(DialogsActions.setClose());
  } finally {
    yield put(
      UsersActions.listAppUsersRequest({
        body: { _includes: 'transportcard,restriction' },
      }),
    );
  }
}

// eslint-disable-next-line import/prefer-default-export
export const denylistSagas = [
  takeLatest(DenyListTypes.LIST_DENYLIST_REQUEST, list),
  takeLatest(DenyListTypes.GET_DENYLIST_REQUEST, get),
  takeLatest(DenyListTypes.CREATE_DENYLIST_REQUEST, create),
];
